/* eslint-disable sort-keys */
import { css } from '@emotion/react';
import colors from './colors';
import rem from './rem';
export const fontSizes = {
    displayExtraExtraSmall: 18,
    displayExtraSmall: 24,
    displaySmall: 32,
    displayMedium: 42,
    displayLarge: 48,
    titleExtraSmall: 12,
    titleSmall: 14,
    titleMedium: 16,
    titleLarge: 18,
    titleExtraLarge: 24,
    titleAlternateExtraSmall: 12,
    titleAlternateSmall: 14,
    titleAlternateMedium: 16,
    titleAlternateLarge: 18,
    titleAlternateExtraLarge: 24,
    bodyExtraSmall: 12,
    bodySmall: 14,
    bodyMedium: 16,
    bodyLarge: 18,
    bodyExtraLarge: 24,
    captionSmall: 10,
    captionMedium: 12,
    captionLarge: 14,
    captionExtraLarge: 16,
};
export const lineHeightSizes = {
    displayExtraExtraSmall: 22,
    displayExtraSmall: 29,
    displaySmall: 38,
    displayMedium: 50,
    displayLarge: 58,
    titleExtraSmall: 15,
    titleSmall: 20,
    titleMedium: 22,
    titleLarge: 26,
    titleExtraLarge: 32,
    titleAlternateExtraSmall: 15,
    titleAlternateSmall: 20,
    titleAlternateMedium: 22,
    titleAlternateLarge: 26,
    titleAlternateExtraLarge: 32,
    bodyExtraSmall: 15,
    bodySmall: 20,
    bodyMedium: 22,
    bodyLarge: 26,
    bodyExtraLarge: 32,
    captionSmall: 12,
    captionMedium: 15,
    captionLarge: 20,
    captionExtraLarge: 22,
};
const getLineHeightScale = ({ fontSize, lineHeight, }) => (lineHeight / fontSize);
// TODO: Change line height calculations to a .map or somethign and then spread into object.
const baseTypeStyles = {
    fontStack: '"Gotham", "Helvetica", "Arial", sans-serif',
    displayFontStack: '"Chronicle Display", serif',
    // fontStack: '"Gotham", serif',
    // displayFontStack: '"Chronicle Display", sans-serif',
    fontWeightThin: 200,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightBook: 500,
    fontWeightDemi: 600,
    fontWeightBold: 700,
    baseFontColor: colors.gray700,
    displayLetterSpacing: rem(0.5),
    displayExtraExtraSmallLineHeight: getLineHeightScale({
        fontSize: fontSizes.displayExtraExtraSmall,
        lineHeight: lineHeightSizes.displayExtraExtraSmall,
    }),
    displayExtraSmallLineHeight: getLineHeightScale({
        fontSize: fontSizes.displayExtraSmall,
        lineHeight: lineHeightSizes.displayExtraSmall,
    }),
    displaySmallLineHeight: getLineHeightScale({
        fontSize: fontSizes.displaySmall,
        lineHeight: lineHeightSizes.displaySmall,
    }),
    displayMediumLineHeight: getLineHeightScale({
        fontSize: fontSizes.displayMedium,
        lineHeight: lineHeightSizes.displayMedium,
    }),
    displayLargeLineHeight: getLineHeightScale({
        fontSize: fontSizes.displayLarge,
        lineHeight: lineHeightSizes.displayLarge,
    }),
    titleExtraSmallLineHeight: lineHeightSizes.titleExtraSmall / fontSizes.titleExtraSmall,
    titleSmallLineHeight: lineHeightSizes.titleSmall / fontSizes.titleSmall,
    titleMediumLineHeight: lineHeightSizes.titleMedium / fontSizes.titleMedium,
    titleLargeLineHeight: lineHeightSizes.titleLarge / fontSizes.titleLarge,
    titleExtraLargeLineHeight: lineHeightSizes.titleExtraLarge / fontSizes.titleExtraLarge,
    titleAlternateExtraSmallLineHeight: lineHeightSizes.titleAlternateExtraSmall / fontSizes.titleAlternateExtraSmall,
    titleAlternateSmallLineHeight: lineHeightSizes.titleAlternateSmall / fontSizes.titleAlternateSmall,
    titleAlternateMediumLineHeight: lineHeightSizes.titleAlternateMedium / fontSizes.titleAlternateMedium,
    titleAlternateLargeLineHeight: lineHeightSizes.titleAlternateLarge / fontSizes.titleAlternateLarge,
    titleAlternateExtraLargeLineHeight: lineHeightSizes.titleAlternateExtraLarge / fontSizes.titleAlternateExtraLarge,
    bodyExtraSmallLineHeight: lineHeightSizes.bodyExtraSmall / fontSizes.bodyExtraSmall,
    bodySmallLineHeight: lineHeightSizes.bodySmall / fontSizes.bodySmall,
    bodyMediumLineHeight: lineHeightSizes.bodyMedium / fontSizes.bodyMedium,
    bodyLargeLineHeight: lineHeightSizes.bodyLarge / fontSizes.bodyLarge,
    bodyExtraLargeLineHeight: lineHeightSizes.bodyExtraLarge / fontSizes.bodyExtraLarge,
    captionLetterSpacing: rem(0.5),
    captionSmallLineHeight: lineHeightSizes.captionSmall / fontSizes.captionSmall,
    captionMediumLineHeight: lineHeightSizes.captionMedium / fontSizes.captionMedium,
    captionLargeLineHeight: lineHeightSizes.captionLarge / fontSizes.captionLarge,
    captionExtraLargeLineHeight: lineHeightSizes.captionExtraLarge / fontSizes.captionExtraLarge,
};
const fontSmoothingStyles = css `
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizelegibility;
`;
// Display
const displayBaseStyles = css `
  ${fontSmoothingStyles}

  color: ${baseTypeStyles.baseFontColor};
  font-family: ${baseTypeStyles.displayFontStack};
  font-weight: ${baseTypeStyles.fontWeightRegular};
  letter-spacing: ${baseTypeStyles.displayLetterSpacing};
`;
export const displayExtraExtraSmallStyles = css `
  ${displayBaseStyles}

  font-size: ${rem(fontSizes.displayExtraExtraSmall)};
`;
export const displayExtraSmallStyles = css `
  ${displayBaseStyles}

  font-size: ${rem(fontSizes.displayExtraSmall)};
`;
export const displaySmallStyles = css `
  ${displayBaseStyles}

  font-size: ${rem(fontSizes.displaySmall)};
`;
export const displayMediumStyles = css `
  ${displayBaseStyles}

  font-size: ${rem(fontSizes.displayMedium)};
`;
export const displayLargeStyles = css `
  ${displayBaseStyles}

  font-size: ${rem(fontSizes.displayLarge)};
`;
// Title
const titleBaseStyles = css `
  ${fontSmoothingStyles}

  color: inherit;
  font-family: ${baseTypeStyles.fontStack};
  font-weight: ${baseTypeStyles.fontWeightBook};
`;
export const titleExtraSmallStyles = css `
  ${titleBaseStyles}

  font-size: ${rem(fontSizes.titleExtraSmall)};
  line-height: ${baseTypeStyles.titleExtraSmallLineHeight};
`;
export const titleSmallStyles = css `
  ${titleBaseStyles}

  font-size: ${rem(fontSizes.titleSmall)};
  line-height: ${baseTypeStyles.titleSmallLineHeight};
`;
export const titleMediumStyles = css `
  ${titleBaseStyles}

  font-size: ${rem(fontSizes.titleMedium)};
  line-height: ${baseTypeStyles.titleMediumLineHeight};
`;
export const titleLargeStyles = css `
  ${titleBaseStyles}

  font-size: ${rem(fontSizes.titleLarge)};
  line-height: ${baseTypeStyles.titleLargeLineHeight};
`;
export const titleExtraLargeStyles = css `
  ${titleBaseStyles}

  font-size: ${rem(fontSizes.titleExtraLarge)};
  line-height: ${baseTypeStyles.titleExtraLargeLineHeight};
`;
// TitleAlternate
const titleAlternateBaseStyles = css `
  ${fontSmoothingStyles}

  color: inherit;
  font-family: ${baseTypeStyles.displayFontStack};
  font-weight: ${baseTypeStyles.fontWeightBook};
  font-style: italic;
`;
export const titleAlternateExtraSmallStyles = css `
  ${titleAlternateBaseStyles}

  font-size: ${rem(fontSizes.titleAlternateExtraSmall)};
  line-height: ${baseTypeStyles.titleAlternateExtraSmallLineHeight};
`;
export const titleAlternateSmallStyles = css `
  ${titleAlternateBaseStyles}

  font-size: ${rem(fontSizes.titleAlternateSmall)};
  line-height: ${baseTypeStyles.titleAlternateSmallLineHeight};
`;
export const titleAlternateMediumStyles = css `
  ${titleAlternateBaseStyles}

  font-size: ${rem(fontSizes.titleAlternateMedium)};
  line-height: ${baseTypeStyles.titleAlternateMediumLineHeight};
`;
export const titleAlternateLargeStyles = css `
  ${titleAlternateBaseStyles}

  font-size: ${rem(fontSizes.titleAlternateLarge)};
  line-height: ${baseTypeStyles.titleAlternateLargeLineHeight};
`;
export const titleAlternateExtraLargeStyles = css `
  ${titleAlternateBaseStyles}

  font-size: ${rem(fontSizes.titleAlternateExtraLarge)};
  line-height: ${baseTypeStyles.titleAlternateExtraLargeLineHeight};
`;
// Body
const bodyBaseStyles = css `
  ${fontSmoothingStyles}

  color: ${baseTypeStyles.baseFontColor};
  font-family: ${baseTypeStyles.fontStack};
  font-weight: ${baseTypeStyles.fontWeightRegular};
`;
export const bodyExtraSmallStyles = css `
  ${bodyBaseStyles}

  font-size: ${rem(fontSizes.bodyExtraSmall)};
  line-height: ${baseTypeStyles.bodyExtraSmallLineHeight};
`;
export const bodySmallStyles = css `
  ${bodyBaseStyles}

  font-size: ${rem(fontSizes.bodySmall)};
  line-height: ${baseTypeStyles.bodySmallLineHeight};
`;
export const bodyMediumStyles = css `
  ${bodyBaseStyles}

  font-size: ${rem(fontSizes.bodyMedium)};
  line-height: ${baseTypeStyles.bodyMediumLineHeight};
`;
export const bodyLargeStyles = css `
  ${bodyBaseStyles}

  font-size: ${rem(fontSizes.bodyLarge)};
  line-height: ${baseTypeStyles.bodyLargeLineHeight};
`;
export const bodyExtraLargeStyles = css `
  ${bodyBaseStyles}

  font-size: ${rem(fontSizes.bodyExtraLarge)};
  line-height: ${baseTypeStyles.bodyExtraLargeLineHeight};
`;
export const bodyBoldStyles = css `
  font-weight: ${baseTypeStyles.fontWeightBook};
`;
// Caption
const captionBaseStyles = css `
  ${fontSmoothingStyles}

  color: inherit;
  font-family: ${baseTypeStyles.fontStack};
  font-weight: ${baseTypeStyles.fontWeightBook};
  letter-spacing: ${baseTypeStyles.captionLetterSpacing};
  text-transform: uppercase;
`;
export const captionSmallStyles = css `
  ${captionBaseStyles}

  font-size: ${rem(fontSizes.captionSmall)};
  line-height: ${baseTypeStyles.captionSmallLineHeight};
`;
export const captionMediumStyles = css `
  ${captionBaseStyles}

  font-size: ${rem(fontSizes.captionMedium)};
  line-height: ${baseTypeStyles.captionMediumLineHeight};
`;
export const captionLargeStyles = css `
  ${captionBaseStyles}

  font-size: ${rem(fontSizes.captionLarge)};
  line-height: ${baseTypeStyles.captionLargeLineHeight};
`;
export const captionExtraLargeStyles = css `
  ${captionBaseStyles}

  font-size: ${rem(fontSizes.captionExtraLarge)};
  line-height: ${baseTypeStyles.captionExtraLargeLineHeight};
`;
const legacyBaseFontStyles = css `
  ${fontSmoothingStyles}

  color: ${baseTypeStyles.baseFontColor};
  font-family: ${baseTypeStyles.fontStack};
  font-style: normal;
  font-weight: ${baseTypeStyles.fontWeightRegular};
  letter-spacing: normal;
  line-height: 1.4;
`;
/* eslint-disable deprecation/deprecation */
const typeStyleDeprecations = {
    /**
     * @deprecated This type style is deprecated. Use `legacyBaseFontStyles` instead.
     */
    baseFont: legacyBaseFontStyles,
    /**
     * @deprecated This type style is deprecated. Please do not manually change the letter spacing. Use `legacyBaseFontStyles` instead.
     */
    bodyLetterSpacing: rem(0.5),
    /**
     * @deprecated This type style is deprecated. Use `displayExtraSmallStyles` instead.
     */
    displayAlternateExtraSmallStyles: displayExtraSmallStyles,
    /**
     * @deprecated This type style is deprecated. Use `displayLargeStyles` instead.
     */
    displayAlternateLargeStyles: displayLargeStyles,
    /**
     * @deprecated This type style is deprecated. Use `displayMediumStyles` instead.
     */
    displayAlternateMediumStyles: displayMediumStyles,
    /**
     * @deprecated This type style is deprecated. Use `displaySmallStyles` instead.
     */
    displayAlternateSmallStyles: displaySmallStyles,
    /**
     * @deprecated This type style is deprecated. Use `displayExtraSmallStyles` instead.
     */
    displayExtraSmall: displayExtraSmallStyles,
    /**
     * @deprecated This type style is deprecated. Use `displaySmallStyles` instead.
     */
    displaySmall: displaySmallStyles,
    /**
     * @deprecated This type style is deprecated. Use `displayMediumStyles` instead.
     */
    displayMedium: displayMediumStyles,
    /**
     * @deprecated This type style is deprecated. Use `displayLargeStyles` instead.
     */
    displayLarge: displayLargeStyles,
    /**
     * @deprecated This type style is deprecated. Use `displayExtraExtraSmallStyles` instead.
     */
    displayExperimentalExtraExtraSmallStyles: displayExtraExtraSmallStyles,
    /**
     * @deprecated This type style is deprecated. Use `displayExtraSmallStyles` instead.
     */
    displayExperimentalExtraSmallStyles: displayExtraSmallStyles,
    /**
     * @deprecated This type style is deprecated. Use `displayFontStack` instead.
     */
    displayExperimentalFontStack: baseTypeStyles.displayFontStack,
    /**
     * @deprecated This type style is deprecated. Use `displayLargeStyles` instead.
     */
    displayExperimentalLargeStyles: displayLargeStyles,
    /**
     * @deprecated This type style is deprecated. Use `displayMediumStyles` instead.
     */
    displayExperimentalMediumStyles: displayMediumStyles,
    /**
     * @deprecated This type style is deprecated. Use `displaySmallStyles` instead.
     */
    displayExperimentalSmallStyles: displaySmallStyles,
    /**
     * @deprecated This type style is deprecated. Use `displayLargeStyles` instead.
     */
    displayExtraLarge: displayLargeStyles,
    /**
     * @deprecated This type style is deprecated. Use `displayLargeStyles` instead.
     */
    displayJumbo: displayLargeStyles,
    /**
     * @deprecated This type style is deprecated. Use `titleExtraLargeStyles` instead.
     */
    headlineExtraSmallStyles: titleExtraLargeStyles,
    /**
     * @deprecated This type style is deprecated. Use `titleExtraLargeStyles` instead.
     */
    headlineLargeStyles: titleExtraLargeStyles,
    /**
     * @deprecated This type style is deprecated. Use `titleExtraLargeStyles` instead.
     */
    headlineMediumStyles: titleExtraLargeStyles,
    /**
     * @deprecated This type style is deprecated. Use `titleExtraLargeStyles` instead.
     */
    headlineSmallStyles: titleExtraLargeStyles,
    /**
     * @deprecated This type style is deprecated. Use `titleExtraLargeStyles` instead.
     */
    primaryHeadlineExtraSmall: titleExtraLargeStyles,
    /**
     * @deprecated This type style is deprecated. Use `titleExtraLargeStyles` instead.
     */
    primaryHeadlineSmall: titleExtraLargeStyles,
    /**
     * @deprecated This type style is deprecated. Use `titleExtraLargeStyles` instead.
     */
    primaryHeadlineMedium: titleExtraLargeStyles,
    /**
     * @deprecated This type style is deprecated. Use `titleExtraLargeStyles` instead.
     */
    primaryHeadlineLarge: titleExtraLargeStyles,
    /**
     * @deprecated This type style is deprecated. Use `titleExtraLargeStyles` instead.
     */
    primaryHeadlineExtraLarge: titleExtraLargeStyles,
    /**
     * @deprecated This type style is deprecated. Use `titleExtraLargeStyles` instead.
     */
    primaryHeadlineJumbo: titleExtraLargeStyles,
    /**
     * @deprecated This type style is deprecated. Use `captionSmallStyles` instead.
     */
    primaryTransactionSmall: captionSmallStyles,
    /**
     * @deprecated This type style is deprecated. Use `captionMediumStyles` instead.
     */
    primaryTransactionMedium: captionMediumStyles,
    /**
     * @deprecated This type style is deprecated. Use `captionLargeStyles` instead.
     */
    primaryTransactionLarge: captionLargeStyles,
    /**
     * @deprecated This type style is deprecated. Use `captionSmallStyles` instead.
     */
    secondaryHeadlineSmall: captionSmallStyles,
    /**
     * @deprecated This type style is deprecated. Use `captionMediumStyles` instead.
     */
    secondaryHeadlineMedium: captionMediumStyles,
    /**
     * @deprecated This type style is deprecated. Use `captionLargeStyles` instead.
     */
    secondaryHeadlineLarge: captionLargeStyles,
    /**
     * @deprecated This type style is deprecated. Use `titleExtraSmallStyles` instead.
     */
    secondaryTransactionSmall: titleExtraSmallStyles,
    /**
     * @deprecated This type style is deprecated. Use `titleSmallStyles` instead.
     */
    secondaryTransactionMedium: titleSmallStyles,
    /**
     * @deprecated This type style is deprecated. Use `titleMediumStyles` instead.
     */
    secondaryTransactionLarge: titleMediumStyles,
    /**
     * @deprecated This type style is deprecated. Use `bodyExtraSmallStyles` instead.
     */
    textExtraSmall: bodyExtraSmallStyles,
    /**
     * @deprecated This type style is deprecated. Use `bodySmallStyles` instead.
     */
    textSmall: bodySmallStyles,
    /**
     * @deprecated This type style is deprecated. Use `bodyMediumStyles` instead.
     */
    textMedium: bodyMediumStyles,
    /**
     * @deprecated This type style is deprecated. Use `bodyLargeStyles` instead.
     */
    textLarge: bodyLargeStyles,
    /**
     * @deprecated This type style is deprecated. Use `bodyLargeStyles` instead.
     */
    textExtraLarge: bodyLargeStyles,
    /**
     * @deprecated This type style is deprecated. Use `bodyBoldStyles` instead.
     */
    textBold: bodyBoldStyles,
    /**
     * @deprecated This type style is deprecated. Use `bodyBoldStyles` instead.
     */
    textEmphasis: bodyBoldStyles,
    /**
     * @deprecated This type style is deprecated. Use `bodyExtraSmallStyles` instead.
     */
    tinyText: bodyExtraSmallStyles,
    /**
     * @deprecated This type style is deprecated. Use `titleSmallStyles` instead.
     */
    formCaption: titleSmallStyles,
    /**
     * @deprecated This type style is deprecated. If you need this type style, ask UX for an alternative.
     */
    formWarning: css `
    ${bodySmallStyles}

    color: #db7b5f;
  `,
    /**
     * @deprecated This type style is deprecated. If you need this type style, ask UX for an alternative.
     */
    formError: css `
    ${bodyExtraSmallStyles}

    color: ${colors.negative800};
  `,
    /**
     * @deprecated This type style is deprecated. Use `titleLargeStyles` instead.
     */
    largePrice: titleLargeStyles,
    /**
     * @deprecated This type style is deprecated. Use `bodyMediumStyles` instead.
     */
    bodyText: bodyMediumStyles,
    /**
     * @deprecated This type style is deprecated. Use `bodyLargeStyles` instead.
     */
    largeBodyText: bodyLargeStyles,
    /**
     * @deprecated This type style is deprecated. Use `titleExtraLargeStyles` instead.
     */
    headlineJumbo: titleExtraLargeStyles,
    /**
     * @deprecated This type style is deprecated. Use `titleExtraLargeStyles` instead.
     */
    headlinePrimary: titleExtraLargeStyles,
    /**
     * @deprecated This type style is deprecated. Use `titleExtraLargeStyles` instead.
     */
    headlineSecondary: titleExtraLargeStyles,
    /**
     * @deprecated This type style is deprecated. Use `captionMediumStyles` instead.
     */
    headlineTertiary: captionMediumStyles,
    /**
     * @deprecated This type style is deprecated. If you need this type style, ask UX for an alternative.
     */
    linkFontColor: '#91ac4c',
    /**
     * @deprecated This type style is deprecated. If you need this type style, ask UX for an alternative.
     */
    transactionFontColor: '#91ac4c',
    /**
     * @deprecated This type style is deprecated. If you need this type style, ask UX for an alternative.
     */
    primaryHeadlineLineHeight: 1.1,
    /**
     * @deprecated This type style is deprecated. If you need this type style, ask UX for an alternative.
     */
    secondaryHeadlineLineHeight: 1.2,
    /**
     * @deprecated This type style is deprecated. If you need this type style, ask UX for an alternative.
     */
    primaryTransactionLineHeight: 1.2,
    /**
     * @deprecated This type style is deprecated. If you need this type style, ask UX for an alternative.
     */
    secondaryTransactionLineHeight: 1.4,
    /**
     * @deprecated This type style is deprecated. If you need this type style, ask UX for an alternative.
     */
    secondaryHeadlineLetterSpacing: rem(0.5),
    /**
     * @deprecated This type style is deprecated. If you need this type style, ask UX for an alternative.
     */
    primaryTransactionLetterSpacing: rem(0.5),
    /**
     * @deprecated This type style is deprecated. If you need this type style, ask UX for an alternative.
     */
    captionLineHeight: 1.2,
    /**
     * @deprecated This type style is deprecated. Please use the line height based on the size of the type style you desire. Ex. captionMediumLineHeight
     */
    displayLineHeight: 1.1,
    /**
     * @deprecated This type style is deprecated. Please use the line height based on the size of the type style you desire. Ex. displayMediumLineHeight
     */
    headlineLineHeight: 1.1,
    /**
     * @deprecated This type style is deprecated. Please use the line height based on the size of the type style you desire. Ex. headlineMediumLineHeight
     */
    textLineHeight: 1.4,
    /**
     * @deprecated This type style is deprecated. Please use the line height based on the size of the type style you desire. Ex. titleAlternateMediumLineHeight
     */
    titleLineHeight: 1.4,
};
/* eslint-enable deprecation/deprecation */
const typeStyles = Object.assign(Object.assign(Object.assign({}, baseTypeStyles), typeStyleDeprecations), { bodyBoldStyles,
    bodyExtraLargeStyles,
    bodyExtraSmallStyles,
    bodyLargeStyles,
    bodyMediumStyles,
    bodySmallStyles,
    captionExtraLargeStyles,
    captionLargeStyles,
    captionMediumStyles,
    captionSmallStyles,
    displayExtraExtraSmallStyles,
    displayExtraSmallStyles,
    displayLargeStyles,
    displayMediumStyles,
    displaySmallStyles,
    titleAlternateExtraLargeStyles,
    titleAlternateExtraSmallStyles,
    titleAlternateLargeStyles,
    titleAlternateMediumStyles,
    titleAlternateSmallStyles,
    titleExtraLargeStyles,
    titleExtraSmallStyles,
    titleLargeStyles,
    titleMediumStyles,
    titleSmallStyles });
export default typeStyles;
